module.exports = __webpack_public_path__ + "img/In Game target_v2-127.cf2527ec.png";